// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkout_wrapper__m-WfO","title":"Checkout_title__iodJ3"};